module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-lightest mt-2"
  }, [_c('div', {
    staticClass: "col-sm-12 py-4"
  }, [(_vm.noTicketsSelected && !_vm.isPricePerGroupCategory) ? _c('div', {
    staticClass: "text-center dark pb-3"
  }, [_vm._v("\n            Empty pax\n        ")]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "w-100 fs-small"
  }, [(!_vm.noTicketsSelected || _vm.totalExtras > 0 || _vm.isPricePerGroupCategory) ? [_vm._m(0)] : _vm._e(), _vm._v(" "), (!_vm.noTicketsSelected || _vm.isPricePerGroupCategory) ? [(_vm.showUniquePrice) ? [_c('tr', [_c('td', [_vm._v("Ticket")]), _vm._v(" "), (_vm.bookingGenderPrices[0].productGenderPriceComponents.length == 0) ? _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.personVatComponents(_vm.bookingGenderPrices[0])))]) : _vm._e(), _vm._v(" "), (_vm.bookingGenderPrices[0].productGenderPriceComponents.length != 0) ? _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.personVat(_vm.bookingGenderPrices[0])))]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [(_vm.getIsLoadingCalculations && _vm.bookingGenderPrices[0].genderPriceType === 3) ? _c('div', [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('div', [_vm._v(_vm._s(_vm.personPrice(_vm.bookingGenderPrices[0], true)))])])])] : _vm._e(), _vm._v(" "), _vm._l((_vm.bookingGenderPrices), function(personType) {
    return (personType.quantityToBook > 0 && _vm.audienceTypes && personType.audienceType != null) ? [_c('tr', [([2, 3].includes(personType.genderPriceType) || personType.genderPriceType == 1 && personType.audienceType != null) ? _c('td', [_c('div', [_vm._v(_vm._s(personType.quantityToBook) + " x " + _vm._s(_vm.genderPriceObj(personType).name))]), _vm._v(" "), _c('div', {
      staticClass: "dark fs-small"
    }, [_vm._v(_vm._s(_vm.genderPriceObj(personType).description))])]) : _vm._e(), _vm._v(" "), (personType.productGenderPriceComponents.length == 0) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.personVatComponents(personType)))]) : _vm._e(), _vm._v(" "), (personType.productGenderPriceComponents.length != 0) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.personVat(personType)))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(_vm.getIsLoadingCalculations && _vm.isToShowLoading) ? _c('div', [_c('loader', {
      attrs: {
        "size": "small",
        "opacity": "0.2"
      }
    })], 1) : _c('div', [_vm._v(_vm._s(_vm.personPrice(personType, false)))])])])] : _vm._e()
  })] : _vm._e(), _vm._v(" "), (_vm.totalExtras > 0) ? [_vm._m(1), _vm._v(" "), _vm._l((_vm.reservation.bookingComponents), function(extra) {
    return (extra.quantity > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(extra.quantity) + " x " + _vm._s(extra.component.name + ' - ' + extra.componentPrice.name))]), _vm._v(" "), _c('td', {
      staticClass: "text-right white-space-nowrap"
    }, [_vm._v(_vm._s(extra.componentPrice.vatType) + " %")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatPrice(extra.componentPrice.grossprice * extra.quantity)) + " €")])]) : _vm._e()
  })] : _vm._e()], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Tax")]), _vm._v(" "), _c('th', {
    staticClass: "priceWidth text-right"
  }, [_vm._v("Price")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "font-weight-600 pt-2"
  }, [_vm._v("Extras")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-11f3f5f5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11f3f5f5"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume/Summary/CostList.vue
// module id = 2925
// module chunks = 0